var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticClass:"group-table",attrs:{"columns":_vm.columns,"row-key":"id","data-source":_vm.list}})
}
var staticRenderFns = []

export { render, staticRenderFns }